import React, { useContext, useEffect, useState } from 'react'
import { CardContent, Typography, Box, InputAdornment } from '@mui/material'
import { formatCurrency, hasAdminAccess } from '../../../utils'
import { CardBox, CardBoxTopBar } from '../../../theme/styleComponents'
import { flexJustifySpaceBetween } from '../../../theme/styleConstants'
import { CustomController } from '../../common/CustomController'
import { AuthContext } from '../../../context'
import { BillStatus, FetchBillDetailsQuery, useIsDepartmentHeadForCaseLazyQuery } from '../../../../generated'

interface NetTotalSectionProps {
  bill?: FetchBillDetailsQuery['fetchBillDetails']['bill']
  netTotal: number
}

const NetTotalSection: React.FC<NetTotalSectionProps> = ({ bill, netTotal }) => {
  const [isDepartmentHead, setIsDepartmentHead] = useState<boolean | null>(null)
  const { currentUser } = useContext(AuthContext)
  const [isDepartmentHeadForCase] = useIsDepartmentHeadForCaseLazyQuery({
    onCompleted: data => {
      if (data.isDepartmentHeadForCase.isDepartmentHead) {
        setIsDepartmentHead(data.isDepartmentHeadForCase.isDepartmentHead)
      }
    }
  })

  const canEditDiscount = hasAdminAccess(currentUser) || isDepartmentHead

  useEffect(() => {
    if (bill?.status === BillStatus.ApprovedByResponsibleAttorney && bill.case?.id && currentUser?.id) {
      isDepartmentHeadForCase({
        variables: { fetchDepartmentHeadInput: { caseId: bill.case.id, userId: currentUser.id } }
      })
    }
  }, [bill?.status, bill?.case?.id, currentUser?.id, isDepartmentHeadForCase])

  return (
    <CardBox mb={3}>
      <CardBoxTopBar sx={{ ...flexJustifySpaceBetween }}>
        <Typography variant="h6" fontWeight={400} color="gray900" fontSize="18px">
          Discount
        </Typography>
        <CustomController
          controllerLabel="Discount"
          controllerName="discountPercentage"
          fullWidth={false}
          startAdornment={<InputAdornment position="start">%</InputAdornment>}
          sx={{ my: 0 }}
          isDisabled={!canEditDiscount}
        />
      </CardBoxTopBar>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ ...flexJustifySpaceBetween, alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={400} color="gray900" fontSize="18px">
            Net Total
          </Typography>
          <Typography variant="h5" fontWeight={600} fontSize="22px">
            {formatCurrency(netTotal)}
          </Typography>
        </Box>
      </CardContent>
    </CardBox>
  )
}

export default NetTotalSection
